// extracted by mini-css-extract-plugin
export var partner = "style-module--partner--b5f33";
export var partner__item = "style-module--partner__item--0e063";
export var partner__itemImg = "style-module--partner__item--img--027b4";
export var partner__row = "style-module--partner__row--64480";
export var partner__title = "style-module--partner__title--94ed1";